<template>
  <div
    style="min-height: calc(100vh - 160px)"
    v-loading="homeLoading"
    element-loading-text="拼命加载中"
  >
    <el-card
      shadow="never"
      class="re-box over-y-show"
      v-if="singleData.statusCheck == 1"
      :body-style="{ padding: '0px' }"
    >
      <div class="flex-x-center" slot="header" style="height: 4em">
        <div
          class="text-bold text-olive text-xl flex-x-center"
          style="margin-left: 0; width: 100%"
        >
          <div>{{ singleData.docName || "采购订单明细" }}</div>
        </div>
        <div class="flex-sub flex-x-center">
          <el-button size="small" type="primary" @click="storageAdd()">发货</el-button>
          <el-button size="small" @click="backHome">返回首页</el-button>
        </div>
      </div>
      <div class="over-y-show padding-lr-sm">
        <div class="flex-x-center padding-xs" style="">
          <div class="flex-sub">
            <label v-if="takeshow('baseSupplierName')">供应商名称</label>
            <span class="text-olive padding-lr-xs" v-if="takeshow('baseSupplierName')">{{
              singleData.baseSupplierName
            }}</span>
          </div>
          <div
            class="over-x-show scroll-x text-right"
            style="width: 70%; white-space: nowrap"
          >
            <label v-if="takeshow('baseSupplierPurchaserOrderNumber')"
              >供应商订单号
            </label>
            <span class="span" v-if="takeshow('baseSupplierPurchaserOrderNumber')">{{
              singleData.baseSupplierPurchaserOrderNumber
            }}</span>
            <label class="turnToPointer" v-if="takeshow('globalSearchNumber')"
              >全局搜索码
            </label>
            <span class="span turnToPointer" v-if="takeshow('globalSearchNumber')">{{
              singleData.globalSearchNumber
            }}</span>
            <label v-if="takeshow('baseSupplierName')">供应商名称 </label>
            <span class="span" v-if="takeshow('baseSupplierName')">{{
              singleData.baseSupplierName
            }}</span>
            <label v-if="takeshow('baseSupplierNumber')">供应商编号 </label>
            <span class="span" v-if="takeshow('baseSupplierNumber')">{{
              singleData.baseSupplierNumber
            }}</span>
            <label v-if="takeshow('basePurchaserName')">采购人：</label>
            <span class="span" v-if="takeshow('basePurchaserName')">{{
              singleData.basePurchaserName
            }}</span>
            <label v-if="takeshow('valueWarehousingWarehouse')">入库仓库：</label>
            <span class="span" v-if="takeshow('valueWarehousingWarehouse')">{{
              singleData.valueWarehousingWarehouse
            }}</span>
            <label>付款方式：</label>
            <span class="span">{{
              singleData.modelCtrlss.STATEMENT_TYPE == 0 ? "现结" : "月结"
            }}</span>

            <span v-if="singleData.salesOrderDocId">
              销售订单:<span style="margin-right: 10px; color: #1476c3">{{
                singleData.salesOrderDocId
              }}</span>
              销售人:<span style="margin-right: 10px; color: #1476c3">{{
                singleData.baseSalespersonName
              }}</span>
              采购人:<span style="margin-right: 10px; color: #1476c3">{{
                singleData.basePurchaserName
              }}</span>
              客户名称:<span style="margin-right: 10px; color: #1476c3">{{
                singleData.baseCustomerName
              }}</span>
              <!-- 收方名称:<span style="margin-right: 10px;color:#1476c3;">{{ singleData.valueCustomerContactName }}</span> -->
              收货地址:<span style="margin-right: 10px; color: #1476c3">{{
                singleData.valueCustomerAddress
              }}</span>
              收货电话:<span style="margin-right: 10px; color: #1476c3">{{
                singleData.valueCustomerPhone
              }}</span>
            </span>
            <!-- 自定义字段 -->
            <span v-for="(item, index) in sysEntityDtoList" :key="index">
              <label>{{ item.fieldName }}</label>
              <span v-if="item.fieldType == 0" class="span">{{
                sysEntityExtDto[
                  item.fieldTag.substring(
                    item.fieldTag.indexOf("-") + 1,
                    item.fieldTag.length
                  )
                ]
              }}</span>
              <span v-if="item.fieldType == 1" class="span">{{
                customSelectDataShow(
                  sysEntityExtDto[
                    item.fieldTag.substring(
                      item.fieldTag.indexOf("-") + 1,
                      item.fieldTag.length
                    )
                  ],
                  JSON.parse(item.fieldTypeRelinfo)
                )
              }}</span>
              <!-- excel -->
              <span style="margin: 0px 10px" v-if="item.fieldType == 2">
                <el-button
                  v-if="
                    sysEntityExtDto[
                      item.fieldTag.substring(
                        item.fieldTag.indexOf('-') + 1,
                        item.fieldTag.length
                      )
                    ] != null &&
                    sysEntityExtDto[
                      item.fieldTag.substring(
                        item.fieldTag.indexOf('-') + 1,
                        item.fieldTag.length
                      )
                    ] != undefined &&
                    sysEntityExtDto[
                      item.fieldTag.substring(
                        item.fieldTag.indexOf('-') + 1,
                        item.fieldTag.length
                      )
                    ] != ''
                  "
                  @click="
                    mainExcelOpen(
                      sysEntityExtDto[
                        item.fieldTag.substring(
                          item.fieldTag.indexOf('-') + 1,
                          item.fieldTag.length
                        )
                      ]
                    )
                  "
                  size="small"
                  type="primary"
                  >打开</el-button
                >
                <el-button
                  v-else
                  size="small"
                  type="primary"
                  @click="
                    mainExcelSuccess(
                      sysEntityExtDto,
                      item.fieldTag.substring(
                        item.fieldTag.indexOf('-') + 1,
                        item.fieldTag.length
                      ),
                      item
                    )
                  "
                  >打开</el-button
                >
              </span>
              <!-- 文件 -->
              <span style="margin: 0px 10px" v-if="item.fieldType == 5">
                <el-button
                  size="small"
                  type="primary"
                  @click="
                    updateFileList(
                      sysEntityExtDto[
                        item.fieldTag.substring(
                          item.fieldTag.indexOf('-') + 1,
                          item.fieldTag.length
                        )
                      ],
                      item
                    )
                  "
                >
                  {{
                    getFileList(
                      sysEntityExtDto[
                        item.fieldTag.substring(
                          item.fieldTag.indexOf("-") + 1,
                          item.fieldTag.length
                        )
                      ]
                    )
                  }}
                </el-button>
              </span>
            </span>
          </div>
        </div>

        <div>
          <myTable
            :overflow="true"
            :id="'myTableOne'"
            :columnType="'columnAll'"
            :list="itemList"
            :titleList="titleList"
            :tableBtnList="itemTableBtnList"
            @btnClick="productBtnClick"
            @inputNumberClick="inputNumberClick"
            @resizableChange="resizableChange"
            @cellClickEvent="cellClickEvent"
            @selectChangeEvent="selectChangeEvent"
            @selectAllCheckboxChange="selectAllCheckboxChange"
            :dialogStatus="1"
            ref="myTableOne"
          ></myTable>
        </div>
        <div>
          <el-descriptions
            direction="horizontal"
            :column="2"
            style="width: 100%"
            border
            size="small"
          >
            <el-descriptions-item
              :labelStyle="{ background: 'white' }"
              v-if="takeshow('modelCtrls')"
            >
              <!-- {{ this.paymentMode }} -->
              <template slot="label"
                ><span class="text-bold text-lg text-darkGray">付款方式</span></template
              >
              <el-input
                placeholder="付款方式"
                class="w-100 border-none"
                :value="singleData.paymentMode"
                size="small"
                :disabled="true"
              >
              </el-input>
            </el-descriptions-item>
            <el-descriptions-item :labelStyle="{ background: 'white' }">
              <template slot="label"
                ><span class="text-bold text-lg text-darkGray">产品金额 </span></template
              >
              <el-input
                placeholder="小计价格(小写)"
                class="w-100"
                v-model="valueTotalAmountFigures"
                size="small"
                :disabled="true"
              >
              </el-input>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <div class="flex">
          <div style="width: calc(50% - 1px)" class="solid-left solid-bottom">
            <div
              class="padding-lr-xs l-h-df over-y-show bg-gray light"
              style="height: 91px"
            >
              备注：
              {{ singleData.remark }}
            </div>
          </div>
          <div style="width: 50%">
            <el-descriptions
              direction="horizontal"
              :column="1"
              style="width: 100%"
              border
              size="small"
            >
              <el-descriptions-item :labelStyle="{ background: 'white' }">
                <template slot="label"
                  ><span class="text-bold text-lg text-darkGray">附加费用</span></template
                >
                <el-input
                  placeholder="附加费用"
                  class="w-100"
                  v-model="singleData.valueTotalOtherExpenses"
                  size="small"
                  :disabled="true"
                >
                </el-input>
              </el-descriptions-item>
              <el-descriptions-item :labelStyle="{ background: 'white' }">
                <template slot="label"
                  ><span class="text-bold text-lg text-darkGray">合计费用</span></template
                >
                <el-input
                  placeholder="合计费用"
                  class="w-100"
                  :value="
                    parseFloat(valueTotalAmountFigures || 0) +
                    parseFloat(singleData.valueTotalOtherExpenses || 0)
                  "
                  size="small"
                  :disabled="true"
                >
                </el-input>
              </el-descriptions-item>
            </el-descriptions>
          </div>
        </div>
      </div>
    </el-card>
    <!-- 发货 -->
    <myOrderAdd
      v-if="htmlDataDialogState.show1"
      :visible="htmlDataDialogState.show1"
      :homeIndex="16"
      :routeType="routeLeavelType"
      :routeQuery="routeLeavelQuery"
      @htmlDataDialogClose="htmlDataDialogClose"
    ></myOrderAdd>
  </div>
</template>
<script>
import { pmgtPurchasesOrderDoc_cooperativeSupplierPurchasesOrderDocView } from '@/api/myController/purchase';
import {
  selcetSetting,
  updateSetting,
  accAdd,
  mulFloat,
  customMenu
} from '@/utils/myUtils';
import { setObjectToSessionStorage, getObjectFromSessionStorage } from '@/utils';
export default {
  props: {
    // 页面传进来判断的值
    routeType: {
      type: Array,
      default: undefined
    },
    // 页面传进来的值
    routeQuery: {
      default: () => ({})
    },
    homeIndex: {
      type: Number,
      default: false
    },
    modelType: {
      type: Number,
      default: 0
    }
  },
  components: {},
  data() {
    return {
      // 新增、详情、修改
      htmlDataDialogState: {
        show1: false,
        show2: false,
        show3: false
      },
      routeLeavelType: 0,
      routeLeavelQuery: {},
      homeIndex: 0,
      // ------------------------------
      homeLoading: false,
      // ---------------------------
      flag: false,
      valueTotalAmountFigures: 0,
      //
      order_details_type: 0, // 0.禁止修改，1.可修改
      hrefProData: {},
      singleData: {},
      // ----------------------
      itemList: [],
      itemTableBtnList: [],
      tableBtnList: [],
      singleRowData: {},
      tableList: [],
      dialogType: 1,
      dialogStatus: 1,
      dialogTitle: '',
      markIndex: 1,
      dialogState: {
        show1: false,
        show2: false,
        show3: false,
        show4: false,
        show5: false
      },
      htmlDataDialogState: {
        show1: false,
        show2: false
      },
      globalSearchDialogData: {},
      materialNumberDialogData: {},
      titleList: [
        {
          id: 1,
          name: '图片', // 必传
          value: 'baseImgUrl', // 必传
          fixedState: false, // 是否固定     //必传
          isShow: true, // 是否显示          //必传
          dataType: 'imageListAll', // 必传
          selectOptionKey: '', // 如果是select下拉框的key 根据字典管理字典类型设置
          selectOptionList: [], // 如果是下拉框 从后台获取下拉框集合
          alwaysEditState: false, // 是否一直处于编辑状态true处于，false不处于
          canEdit: true, // 是否不可编辑，true可编辑，false不可编辑
          width: 80
        },
        {
          id: 0,
          name: '产品图纸',
          value: 'baseDrawingFile',
          fixedState: false,
          isShow: true,
          dataType: 'fileList',
          canEdit: false,
          width: 60
        },
        {
          id: 0,
          name: '产品附件',
          value: 'baseFileList',
          fixedState: false,
          isShow: true,
          dataType: 'fileList',
          canEdit: false,
          width: 60
        },
        {
          id: 0,
          name: '订单图片',
          value: 'valueImgList',
          fixedState: false,
          isShow: true,
          dataType: 'fileList',
          canEdit: false,
          width: 60
        },
        {
          id: 0,
          name: '订单附件',
          value: 'valueFileList',
          fixedState: false,
          isShow: true,
          dataType: 'fileList',
          canEdit: false,
          width: 60
        },
        {
          id: 2,
          name: '产品编号', // 必传
          value: 'baseMaterialNumber', // 必传
          fixedState: false, // 是否固定     //必传
          isShow: true, // 是否显示          //必传
          dataType: 'text', // 必传
          color: '#049eff',
          selectOptionKey: '', // 如果是select下拉框的key 根据字典管理字典类型设置
          selectOptionList: [], // 如果是下拉框 从后台获取下拉框集合
          alwaysEditState: false, // 是否一直处于编辑状态true处于，false不处于
          canEdit: false, // 是否不可编辑，true可编辑，false不可编辑
          width: 120
        },
        {
          id: 3,
          name: '产品名称',
          value: 'baseMaterialName',
          fixedState: false,
          isShow: true,
          dataType: 'customTable',
          alwaysEditState: false,
          canEdit: false,
          width: 180
        },
        {
          id: 4,
          name: '规格型号',
          value: 'specifications',
          fixedState: false,
          isShow: true,
          dataType: 'textList', // 必传
          alwaysEditState: false,
          canEdit: false,
          width: 260
        },
        {
          id: 2,
          name: '客户料号', // 必传
          value: 'baseCustomerMaterialNumber', // 必传
          fixedState: false,
          isShow: true,
          dataType: 'text',
          alwaysEditState: false,
          canEdit: false,
          width: 120
        },
        {
          id: 3,
          name: '品牌',
          value: 'baseBrand',
          fixedState: false,
          isShow: true,
          dataType: 'text',
          alwaysEditState: false,
          canEdit: false,
          width: 120
        },
        {
          id: 3,
          name: '送货方式',
          value: 'baseDeliveryMethod',
          fixedState: false,
          isShow: true,
          dataType: 'select',
          selectOptionKey: 'sys_del_type',
          selectOptionList: [],
          alwaysEditState: false,
          canEdit: false,
          width: 180
        },
        // {
        //   id: 5,
        //   name: "产品类别",
        //   value: "baseMaterialTypeName",
        //   fixedState: false,
        //   isShow: true,
        //   dataType: "text",
        //   selectOptionKey: "", //如果是select下拉框的key 根据字典管理字典类型设置
        //   selectOptionList: [], //如果是下拉框 从后台获取下拉框集合
        //   canEdit: false,
        //   width: 160,
        // },
        {
          id: 6,
          name: '单位',
          value: 'materialUnit',
          fixedState: false,
          isShow: true,
          dataType: 'text',
          selectOptionKey: '',
          selectOptionList: [],
          canEdit: false,
          width: 100
        },
        {
          id: 7,
          name: '采购数量',
          value: 'baseAmount',
          fixedState: false,
          isShow: true,
          dataType: 'numberAccuracy',
          alwaysEditState: false,
          canEdit: false,
          width: 120
        },
        // {
        //   id: 71,
        //   name: "冻结数量",
        //   value: "valueUnreceiptLockAmount",
        //   fixedState: false,
        //   isShow: true,
        //   dataType: "numberAccuracy",
        //   alwaysEditState: false,
        //   canEdit: false,
        //   width: 120,
        // },
        {
          id: 8,
          name: '采购单价',
          value: 'baseMaterialUnitprice',
          fixedState: false,
          isShow: true,
          dataType: 'priceAccuracy',
          canEdit: false,
          alwaysEditState: false,
          width: 120
        },
        {
          id: 9,
          name: '采购单价(未税)',
          value: 'baseMaterialUnitpriceUntaxed',
          fixedState: false,
          isShow: true,
          dataType: 'priceAccuracy',
          canEdit: false,
          alwaysEditState: false,
          width: 120
        },
        {
          id: 10,
          name: '税率(%)',
          value: 'baseTaxRate',
          fixedState: false,
          isShow: true,
          dataType: 'number',
          canEdit: false,
          alwaysEditState: false,
          width: 120
        },
        {
          id: 13,
          name: '来源单据',
          value: 'sourcesName',
          fixedState: false,
          isShow: true,
          dataType: 'text',
          canEdit: false,
          alwaysEditState: false,
          width: 180
        },
        {
          id: 11,
          name: '采购总价',
          value: 'baseMaterialTotalprice',
          dataType: 'priceAccuracy',
          fixedState: false,
          isShow: true,
          canEdit: false,
          width: 120
        },
        {
          id: 12,
          name: '采购总价(未税)',
          value: 'baseMaterialTotalpriceUntaxed',
          fixedState: false,
          isShow: true,
          dataType: 'priceAccuracy',
          canEdit: false,
          alwaysEditState: false,
          width: 120
        },
        {
          id: 13,
          name: '销售交期',
          value: 'baseDeliveryDate',
          fixedState: false,
          isShow: true,
          dataType: 'dateTime',
          canEdit: false,
          alwaysEditState: false,
          width: 180
        },
        {
          id: 12,
          name: '采购交期',
          value: 'baseReceiptDate',
          fixedState: false,
          isShow: true,
          dataType: 'dateTime',
          canEdit: false,
          alwaysEditState: false,
          width: 180
        },
        {
          id: 4,
          name: 'BOM版本号',
          value: 'baseBomVersionV2',
          fixedState: false,
          isShow: true,
          dataType: 'text',
          selectOptionKey: '',
          selectOptionList: [],
          alwaysEditState: false,
          canEdit: false,
          width: 80,
          color: '#409eff'
        },
        {
          id: 14,
          name: '备注',
          value: 'remark',
          fixedState: false,
          isShow: true,
          dataType: 'textarea',
          canEdit: false,
          alwaysEditState: false,
          width: 180
        }
      ],
      sysEntityDtoList: [],
      sysEntityExtDto: {}
    };
  },
  created() {
    this.hrefProData = this.routeQuery;
    this.getList();
  },
  methods: {
    getList() {
      this.homeLoading = true;
      pmgtPurchasesOrderDoc_cooperativeSupplierPurchasesOrderDocView({
        purchasesOrderDocId: this.hrefProData.purchasesOrderDocId
      }).then(async (res) => {
        var ist = true;
        for (let i = 0; i < res.data.data.purchasesOrderDocDetailList.length; i++) {
          let item = res.data.data.purchasesOrderDocDetailList[i];
          try {
            if (item.baseBomVersion) {
              item.baseBomVersionV2 = 'V' + item.baseBomVersion;
            } else {
              item.baseBomVersionV2 = '---';
            }
          } catch (error) {}
          if (item.valueUnreceiptLockAmount != item.baseAmount) ist = false;
          item.wareStock = 0;
          item.baseDeliveryDate = item.baseDeliveryDate || null;
          item.baseReceiptDate = item.baseReceiptDate || null;
          item.materialId = item.baseMetaMaterialId;
          item.baseDeliveryMethod = item.baseDeliveryMethod;
          item.materialUnit = item.baseMaterialUnitName;
          item.sourceMaterialName = item.sourceMaterialName;
          item.sourceMaterialId = item.sourceMaterialId;
          item.specGroupId = item.baseMetaSpecgroupId;
          try {
            item.specifications = JSON.parse(item.baseMaterialSpecDesc);
          } catch (error) {
            item.specifications = [];
          }
        }
        // 处理主表
        try {
          res.data.data.modelCtrlss = JSON.parse(res.data.data.modelCtrl || '{}');
        } catch (error) {}
        this.itemList = res.data.data.purchasesOrderDocDetailList;
        this.specialColumnTotal();
        this.singleData = res.data.data;
        this.singleData.ist = ist;
        this.homeLoading = false;
      });
    },
    // 发货
    storageAdd() {
      this.routeLeavelQuery = this.singleData;
      this.routeLeavelType = 1;
      this.htmlDataDialogState.show1 = true;
    },
    specialColumnTotal() {
      let sum = 0;
      this.itemList.forEach((item) => {
        if (item.baseMaterialName && item.baseMaterialName != '') {
          sum = accAdd(sum, item.baseMaterialTotalprice);
        }
      });
      this.valueTotalAmountFigures = sum;
    },
    takeshow(data) {
      return true;
      return;
      let rusult = this.showList?.includes(data);
      return rusult;
    },
    takeMustshow(data) {
      let rusult = this.showMustList?.includes(data);
      return rusult;
    },
    cellClickEvent(row, column) {
      switch (column.field) {
        default:
          break;
      }
    },
    customSelectDataShow(val, list) {
      if (list) {
        let single = list.filter((item) => {
          return item.value == val;
        });
        return single.length > 0 ? single[0].label : '';
      }
    },
    htmlDataDialogClose(state, data) {
      this.htmlDataDialogState.show1 = false;
      this.htmlDataDialogState.show2 = false;
      this.htmlDataDialogState.show3 = false;
      this.getList();
    },
    backHome() {
      this.$emit('backHome');
    }
  }
};
</script>
<style scoped>
.span {
  margin-right: 20px;
  color: #1476c3;
}

.input {
  width: 180px;
  margin-right: 20px;
}

.btnOne {
  background: #1476c3;
  color: white;
}

.title {
  display: flex;
  position: relative;
  margin-bottom: 10px;
  /* flex-direction: row ;
        justify-content:center; */
}

.title----font {
  color: #1476c3;
  position: relative;
  margin-left: 44%;
  font-size: 25px;
  font-weight: bold;
}

.title--button {
  position: absolute;
  margin-left: 1px;
  margin-top: 0.1%;
}

.checkImg {
  height: 75px;
  width: 150px;
  position: absolute;
  top: 15px;
  right: 20px;
  z-index: 99;
  /* opacity: 0.5; */
  transform: rotate(-10deg);
}

.turnToPointer {
  cursor: pointer;
}
</style>
